var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "layout" } },
    [
      _c("IHeader"),
      _c(
        "Row",
        [
          _c(
            "Col",
            {
              attrs: {
                xs: _vm.sideBarFix[0],
                sm: _vm.sideBarFix[1],
                md: _vm.sideBarFix[2],
                lg: _vm.sideBarFix[3],
                xl: _vm.sideBarFix[4],
              },
            },
            [_c("ISidebar", { ref: "sidebar", staticClass: "sidebar_left" })],
            1
          ),
          _c(
            "Col",
            {
              attrs: {
                xs: _vm.containerFix[0],
                sm: _vm.containerFix[1],
                md: _vm.containerFix[2],
                lg: _vm.containerFix[3],
                xl: _vm.containerFix[4],
              },
            },
            [
              _c("ITabs"),
              _c(
                "div",
                { attrs: { id: "container" } },
                [
                  _c(
                    "div",
                    { attrs: { id: "main" } },
                    [
                      _c("Button", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.expand && !_vm.isMobile,
                            expression: "expand && !isMobile",
                          },
                        ],
                        staticClass: "menuBtn",
                        attrs: {
                          size: "small",
                          type: "primary",
                          icon: "ios-arrow-back",
                        },
                        on: { click: _vm.changFix },
                      }),
                      _c("Button", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: !_vm.expand && !_vm.isMobile,
                            expression: "!expand && !isMobile",
                          },
                        ],
                        staticClass: "menuBtn",
                        attrs: {
                          size: "small",
                          type: "primary",
                          icon: "ios-arrow-forward",
                        },
                        on: { click: _vm.changFix },
                      }),
                      _c(
                        "keep-alive",
                        [_vm.keepAlive ? _c("router-view") : _vm._e()],
                        1
                      ),
                      !_vm.keepAlive ? _c("router-view") : _vm._e(),
                    ],
                    1
                  ),
                  _c("IFooter"),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c("IError"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }